import React from "react"
import { TitleCenter } from "../../ui"

export const InfoCell = () => (
  <TitleCenter>
    Antes de enviar os documentos preencha os dados bancários!
  </TitleCenter>
)
